export default __webpack_public_path__ + "static/media/startupRealCase2-mobile-en.0b834537.jpg";